import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err)
}

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeView"),
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'zyindex',
        component: () => import('@/components/ZYIndex.vue')
      },
      {
        path: '/core',
        name: 'zycore',
        component: () => import('@/components/ZYCore.vue')
      },
      {
        path: '/help',
        name: 'zyhelp',
        component: () => import('@/components/ZYHelp.vue')
      },
      {
        path: '/news',
        name: 'zynews',
        component: () => import('@/components/ZYNews.vue')
      },
      {
        path: '/contact',
        name: 'zycontact',
        component: () => import('@/components/ZYContact.vue')
      },
      {
        path: '/about',
        name: 'zyabout',
        component: () => import('@/components/ZYAbout.vue')
      },
    ]
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach(()=>{
  window.scrollTo(0,0);
})

export default router;
